export default __webpack_public_path__ + "static/media/cha_medic_hibiscus.6dceca44.png";